import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8 11.15C7.53056 11.15 7.15 11.5306 7.15 12C7.15 12.4694 7.53056 12.85 8 12.85H11.15V16C11.15 16.4694 11.5306 16.85 12 16.85C12.4694 16.85 12.85 16.4694 12.85 16L12.85 12.85H16C16.4694 12.85 16.85 12.4694 16.85 12C16.85 11.5306 16.4694 11.15 16 11.15H12.85L12.85 8C12.85 7.53056 12.4694 7.15 12 7.15C11.5306 7.15 11.15 7.53056 11.15 8V11.15H8Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
